import get from 'lodash/get';

import ParamsService from '@/utils/ParamsService';
import { flattenPreserveArrays, convertSimpleTypeArrayToObjectArray, isMappingString } from '@/utils/helpers';

export default {
	props: {},
	computed: {
		isTableOptionsMode() {
			return this.fieldOptions.dropdown_mode?.value === 1;
		},
		tableSourceRows() {
			let source = this.fieldOptions.previous_steps.table_mode_source.value; // might be a string or an object
			if (isMappingString(source)) {
				// if its a string - its {{ }} path to a previous steps result, otherwise it's an object..
				const sourceWithoutBrackets = ParamsService.removeBracketsFromValue(source);
				if (!this.previousSteps) {
					return [];
				}
				source = get(this.previousSteps, sourceWithoutBrackets); // Read the data from previous steps
			}
			return convertSimpleTypeArrayToObjectArray(source);
		},
		dynamicTableOptions() {
			const tableSourceRowsIsNotArr = !Array.isArray(this.tableSourceRows);
			// if tableSourceRows not an array return empty array
			if (!this.tableSourceRows || tableSourceRowsIsNotArr) {
				return [];
			}
			const isOptionValueMode = Boolean(this.fieldOptions.option_value?.enabled);
			const { text_column: text, value_column: value } = this.fieldOptions.table_mode;
			const options = this.tableSourceRows
				.filter((row) => {
					const flattenedRow = flattenPreserveArrays(row);
					return text in flattenedRow && (isOptionValueMode && value ? value in flattenedRow : true);
				})
				.map((row, index) => {
					const flattenedRow = flattenPreserveArrays(row);
					return {
						id: `${index}`,
						text: flattenedRow[text],
						value: isOptionValueMode && value ? flattenedRow[value] : flattenedRow[text],
						required: false,
					};
				});
			return options;
		},
	},
	methods: {},
};
